import { render, staticRenderFns } from "./exclamation-triangle.vue?vue&type=template&id=5baea0ca&scoped=true&"
import script from "./exclamation-triangle.vue?vue&type=script&lang=js&"
export * from "./exclamation-triangle.vue?vue&type=script&lang=js&"
import style0 from "./exclamation-triangle.vue?vue&type=style&index=0&id=5baea0ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baea0ca",
  null
  
)

export default component.exports